import { useAuth } from '../context/AuthContext';

/**
 * Returns true if the user is allowed to access a given permission key.
 *
 * Logic:
 * - If the user has manually assigned permissions for the selected institution
 *   → check if the permission key is in the list (role is ignored)
 *   → also returns true if any key in `alsoGrantIfAny` is present (e.g. parent menu
 *     should be visible when a sub-menu permission is granted)
 * - If no manual permissions → return roleBasedFallback (existing role check)
 */
export function usePermission(key: string, roleBasedFallback: boolean, alsoGrantIfAny?: string[]): boolean {
  const { user, selectedInstitutionId } = useAuth();
  const perms: string[] = (selectedInstitutionId && user?.permissions?.[selectedInstitutionId]) || [];
  const hasManual = perms.length > 0;
  if (!hasManual) return roleBasedFallback;
  return perms.includes(key) || (alsoGrantIfAny?.some(k => perms.includes(k)) ?? false);
}
